import { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./imagePreview.scss";

const ImagePreview = ({
  title,
  imageUrl,
  altText = "Vista previa",
  width = "100%",
  height = "220px",
  objectFit = "cover",
}) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  // ── Sin imagen ─────────────────────────────────────────────────────────────
  if (!imageUrl || error) {
    return (
      <div className="img-preview img-preview--empty">
        {title && <p className="img-preview__title">{title}</p>}
        <div className="img-preview__placeholder">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="3" width="18" height="18" rx="3" />
            <circle cx="8.5" cy="8.5" r="1.5" />
            <polyline points="21 15 16 10 5 21" />
          </svg>
          <span>{error ? "Error al cargar la imagen" : "Sin vista previa disponible"}</span>
        </div>
      </div>
    );
  }

  // ── Con imagen ─────────────────────────────────────────────────────────────
  return (
    <div className="img-preview">
      {title && <p className="img-preview__title">{title}</p>}

      <div className="img-preview__wrapper" style={{ height }}>
        {/* Skeleton mientras carga */}
        {!loaded && (
          <div className="img-preview__skeleton">
            <div className="img-preview__spinner" />
          </div>
        )}

        <LazyLoadImage
          src={imageUrl}
          alt={altText}
          width={width}
          height={height}
          effect="blur"
          className={`img-preview__img ${loaded ? "img-preview__img--loaded" : ""}`}
          style={{ objectFit }}
          afterLoad={() => setLoaded(true)}
          onError={() => setError(true)}
        />
      </div>
    </div>
  );
};

export default ImagePreview;